import type { LogLevelDesc } from 'loglevel';
import log from 'loglevel';
import { global } from 'styled-jsx/css';

log.setDefaultLevel('info');

// @ts-ignore
if (global.document) {
  const level = document.cookie
    .split(';')
    .find(text => text.includes('DEBUG_LEVEL'))
    ?.split('=')[1] as LogLevelDesc;

  log.setLevel(level || 'silent');
}

export const logger = log;
